const initialCompetenciaData = {
	descripcion:'',
	icono:'',
	color:'',
	anulado:'',
	anuladoFec:'',
	codUsuAnula:''
};

const initialArrayCompetenciaData = [];

export { initialCompetenciaData, initialArrayCompetenciaData };
